/**
 * Extract a human-readable message from an unknown thrown value.
 *
 * Handles all the shapes Supabase throws: Error subclasses (AuthError,
 * FunctionsError, StorageError), plain `{ message }` objects (PostgrestError),
 * and bare strings. `instanceof Error` alone misses PostgrestError, so prefer
 * this everywhere error messages are surfaced to users.
 */
export function getErrorMessage(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (typeof e === 'string') return e;
  if (e && typeof e === 'object' && 'message' in e) {
    const m = (e as { message?: unknown }).message;
    return typeof m === 'string' ? m : m == null ? '' : String(m);
  }
  return '';
}
